const selectors = {
  button: '[data-scroll-top-button]'
}

class ScrollTopButton {
  constructor(element) {
    this.button = element;
  }

  handleClick(event) {
    event.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  setVisibility() {
    if (window.scrollY > 400) {
      this.button.setAttribute('aria-hidden', 'false');
    } else {
      this.button.setAttribute('aria-hidden', 'true');
    }
  }

  init() {
    document.addEventListener('scroll', () => this.setVisibility());
    this.button.addEventListener('click', (event) => this.handleClick(event));
  }
}

export default function () {
  const buttonElement = document.querySelector(selectors.button);
  if (!buttonElement) return;

  const button = new ScrollTopButton(buttonElement);
  button.init();
};